import React, { useRef } from 'react'
import {
  Button,
  Text,
  Box,
  Heading,
  useDisclosure,
  VStack,
  HStack,
  PinInput,
  PinInputField
} from '@chakra-ui/react'
import { Link as RouterLink } from 'react-router-dom'
import { Controller, useForm } from 'react-hook-form'
import { AuthLayout, ActionModal } from '../../components'
import { ROUTES } from '../../contants'
import useResetStore from '../../state/Reset.store'

const ChangePin = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [loading, setPin] = useResetStore((state) => [state.loading, state.setPin])
  const password = useRef({})
  const {
    handleSubmit,
    control,
    watch,
    formState: { errors, isValid }
  } = useForm()
  password.current = watch('pin', '')

  const onSubmit = async ({ pin }: { pin: string }) => {
    try {
      await setPin(pin)
      onOpen()
    } catch (error) {
      console.log(error)
    }
  }
  return (
    <AuthLayout>
      <VStack
        flex="1"
        justify="center"
        align="flex-start"
        w="full"
        as="form"
        onSubmit={handleSubmit(onSubmit)}>
        <Heading
          fontFamily="'Poppins', sans-serif"
          lineHeight="1.5"
          fontSize="1.6rem"
          fontWeight="500"
          mb="1.4rem"
          color="brand.blue">
          Set a New PIN
        </Heading>
        <Text fontSize="1.2rem" mb="2rem !important">
          Please enter a new pin{' '}
        </Text>

        <Text mb="1rem" color="black">
          New PIN
        </Text>

        <HStack mb="2rem !important" w="full">
          <Controller
            control={control}
            name="pin"
            rules={{
              required: true,
              minLength: 6,
              maxLength: 6,
              validate: (value) => value === password.current || 'The passwords do not match'
            }}
            render={({ field: { onChange } }) => (
              <PinInput
                isInvalid={errors.pin}
                size="lg"
                onChange={onChange}
                otp
                mask
                placeholder="">
                {Array(6)
                  .fill('')
                  .map(() => (
                    <PinInputField color="black" />
                  ))}
              </PinInput>
            )}
          />
        </HStack>

        <Text color="black" mt="2.4rem">
          Confirm PIN
        </Text>

        <HStack mb="2rem !important" w="full">
          <Controller
            control={control}
            name="confirm_pin"
            rules={{ required: true, minLength: 6, maxLength: 6 }}
            render={({ field: { onChange } }) => (
              <PinInput
                isInvalid={errors.confirm_pin}
                size="lg"
                onChange={onChange}
                otp
                mask
                placeholder="">
                {Array(6)
                  .fill('')
                  .map(() => (
                    <PinInputField color="black" />
                  ))}
              </PinInput>
            )}
          />
        </HStack>

        <Button
          isLoading={loading}
          type="submit"
          mb="8.7rem"
          my="2.4rem"
          isFullWidth
          variant="blue">
          Save Changes
        </Button>
      </VStack>

      <ActionModal message="PIN Updated Successfully" isOpen={isOpen} onClose={onClose} />
    </AuthLayout>
  )
}

export { ChangePin }
